import { motion } from "framer-motion";
import type { ReactNode } from "react";
import { type PressEvent, useHover, usePress } from "react-aria";
import { HStack, MenuOptionItem } from "widgets";

import { formatRegion } from "../../../utils/region.ts";
import type { GenomeMember } from "../utils/process-genome-data.ts";

export const ItemButton = ({
  member,
  onPress,
  hoverElement,
}: {
  member: GenomeMember;
  onPress: (e: PressEvent) => void;
  hoverElement: ReactNode;
}) => {
  const { pressProps } = usePress({ onPress });
  const { hoverProps, isHovered } = useHover({});

  const variants = {
    visible: {
      opacity: 1,
      transition: {
        duration: 0.3,
      },
    },
    hidden: {
      opacity: 0,
      transition: {
        duration: 0,
      },
    },
  };

  return (
    <HStack
      domProps={hoverProps}
      style={{ background: isHovered ? "var(--hover-background)" : undefined, paddingRight: 5, borderRadius: 3 }}
    >
      <div {...pressProps} style={{ width: "100%" }}>
        <MenuOptionItem
          title={member.memberName}
          description={formatRegion(member.contigName, member.start, member.stop)}
          style={{ maxWidth: 700 }} // The default value in the widget is set to 280px
        />
      </div>
      <motion.div
        variants={variants}
        initial="hidden"
        animate={isHovered ? "visible" : "hidden"}
        style={{ position: "relative", display: "flex", alignItems: "center" }}
      >
        {hoverElement}
      </motion.div>
    </HStack>
  );
};
